import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EksisKategoriPage } from './eksis-kategori.page';

const routes: Routes = [
  {
    path: '',
    component: EksisKategoriPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EksisKategoriPage]
})
export class EksisKategoriPageModule {}
